import logoPsi from "@/assets/logoPsiMammoliti.svg";
import type { FormacionCertificado } from "@/hooks/api/comunidad";
import { formatCertificadoDate } from "../certificadoFormacionPdf";

interface CertificadoMiniaturaProps {
  certificado: FormacionCertificado;
  className?: string;
}

/**
 * Vista en miniatura del certificado de participación — la misma composición que el PDF
 * (`certificadoFormacionPdf.ts`: logo, "PSI MAMMOLITI", subtítulo, nombre de la formación,
 * "otorgado a", nombre y fecha), en HTML para que se vea nítida a cualquier tamaño (las letras
 * se miden en `cqw`: crecen y se achican con el ancho de la miniatura). Si cambia
 * el diseño del PDF, cambiar también esto.
 */
export const CertificadoMiniatura = ({ certificado, className = "" }: CertificadoMiniaturaProps) => {
  const date = formatCertificadoDate(certificado.startsAt);
  return (
    <div
      aria-label={`Vista previa del certificado de ${certificado.formacionTitle}`}
      className={`relative aspect-[1.414/1] w-full rounded-lg border-2 border-[#8475B3] bg-white p-1 shadow-[0_4px_14px_rgba(109,87,188,0.15)] [container-type:inline-size] ${className}`}
    >
      <div className="flex h-full flex-col items-center justify-center gap-[3%] rounded-[5px] border border-[#C9BCE8] px-[8%] text-center">
        <img src={logoPsi} alt="" className="h-[18%] w-auto" />
        <span className="text-[2.4cqw] font-semibold uppercase tracking-[0.15em] text-[#665090]">Psi Mammoliti</span>
        <span className="mt-[2%] text-[2.4cqw] text-[#665090]">
          Certificado de participación en la formación para psicólogos/as
        </span>
        <span className="line-clamp-2 text-[3.4cqw] font-bold uppercase leading-tight text-[#2D2049]">
          “{certificado.formacionTitle}”
        </span>
        <span className="mt-[2%] text-[2.1cqw] font-semibold uppercase tracking-[0.2em] text-[#8475B3]">Otorgado a</span>
        <span className="border-b border-[#C9BCE8] px-[3%] text-[4.2cqw] font-bold leading-tight text-[#2D2049]">
          {certificado.name} {certificado.surname}
        </span>
        {date && <span className="text-[2.4cqw] text-[#665090]">{date}</span>}
      </div>
    </div>
  );
};

export default CertificadoMiniatura;
